/**
 * Formats a number with 2 decimal places
 * - Returns empty string if value is falsy
 * - Returns the original value if it's not a number
 * - Returns the absolute value in parentheses if negative
 * - Returns the number with 2 decimal places otherwise
 *
 * @param {number|string} val - The value to format
 * @returns {string} The formatted number as a string
 */
export const formatNumber = val => {
  if (typeof val !== 'number') return val; // Enforce input is a number only
  if (isNaN(val)) return val;
  if (val < 0) return `(${Math.abs(val).toFixed(2)})`;
  return val.toFixed(2);
};

export default formatNumber;
